/**
 * d16n::legacy
 * d16n::source:<PProductB2AG.vue>
 * d16n::helpers-file
 */

import type { Identity } from '../PProductDetailBlockIdentity/typings'
import type { Product } from '../typings'

export function dedupPrecocities(product: Product) {
  const maybeDuplicatedPrecocities = product.variants?.map((variant) => variant.precocity)
  const uniqPrecocities = Array.from(new Set(maybeDuplicatedPrecocities))
  return uniqPrecocities.join(', ')
}

function formatBoolean(data: true): 'Oui'
function formatBoolean(data: false): 'Non'
function formatBoolean<T>(data: T): T
function formatBoolean<T>(data: boolean | T) {
  return typeof data === 'boolean' ? (data && 'Oui') || 'Non' : data
}

export function buildIdentities(product: Product, precocities: string, displayValue: boolean): Identity[] {
  return [
    { label: '', value: product.organic && "SEMENCE issue de l'Agriculture Biologique" },
    { label: 'Destination', value: product.valuation?.join(', ') },
    { label: 'Nom variété', value: product.name },
    { label: 'Obtenteur', value: displayValue ? product.provider : undefined },
    {
      label: 'Tolérance au Chlortoluron',
      value: displayValue ? formatBoolean(product.chlortoluron) : undefined,
    },
    { label: 'Résistance(s)', value: product.resistance },
    { label: 'Génération', value: product.generation },
    { label: 'Alternativité', value: product.alternativity },
    { label: 'Type variétal', value: product.profile },
    { label: 'Précocité', value: precocities },
    { label: 'Composants du mélange', value: product.mixComponents },
  ]
}
